import React from "react";
import styles from "./finalresult.module.css";
import Button from "../components/Button";
import { Chartconfig, markPos } from "../config/chart";
import ReactHighcharts from "react-highcharts";
import { useEffect } from "react";
import html2canvas from "html2canvas";
import { useRef } from "react";
import { useState } from "react";
import Share from "../components/Share";
import { useData } from "../contexts/DataContext";
import SubContent from "../components/SubContent";
import { useMemo } from "react";
import faster from "../static/images/component_svg/faster.svg";
import same from "../static/images/component_svg/same.svg";
import slower from "../static/images/component_svg/slower.svg";
import { description } from "../config/Summary";
import Bar from "../components/Bar";

function FinalResult(props) {
  const resultRef = useRef(null);
  const { result, suggestion } = useData();
  const [imageUrl, setImageUrl] = useState(null);
  const performanceImages = {
    faster,
    same,
    slower,
  };

  const detailPerformance = useMemo(() => {
    if (result.performanceLists && result.brainAgeLists) {
      if (result.performance) {
        return {
          status: result.brainAgeLists[result.performance],
          detail: result.performanceLists[result.performance],
          descript: description[result.performance],
        };
      }
    }
  }, [result]);

  useEffect(() => {
    if (resultRef.current) {
      html2canvas(resultRef.current, {
        scale: window.devicePixelRatio,
        useCORS: true,
      }).then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        setImageUrl(imgData);
      });
    }
  }, []);

  return (
    <div className={styles.body}>
      <div className={styles.headtext}>ผลลัพธ์ของคุณคือ</div>
      <div className={styles.allbox}>
        {imageUrl ? (
          <img src={imageUrl} alt="Result" className={styles.resultImage} />
        ) : (
          <div className={styles.content} ref={resultRef}>
            <div className={styles.main_content}>
              <div className={styles.top_section}>
                <div
                  className={styles.brainImage}
                  style={{
                    backgroundImage: `url(${
                      performanceImages[result.performance]
                    })`,
                  }}
                ></div>
                <h1>{detailPerformance.status}</h1>
              </div>
              <div className={styles.age_section}>
                <div className={styles.real_age}>
                  <div className={styles.text}>อายุจริง</div>
                  <div className={styles.score}>
                    {result.age}{result.age === 68 ? "+" : ""}
                    <div className={styles.year}> ปี</div>
                  </div>
                </div>
                <div className={styles.score_age}>
                  <div className={styles.text}>อายุสมอง</div>
                  <div className={styles.score}>
                    {result.brainAge}
                    <div className={styles.year}> ปี</div>
                  </div>
                </div>
              </div>
              <div className={styles.explain_text}>
                {detailPerformance.detail}
              </div>
              <div className={styles.chart_section}>
                <Bar status={result.performance} />
              </div>
              <div className={styles.explain_text}>
                {detailPerformance.descript}
              </div>
            </div>
          </div>
        )}
        <SubContent result={result} />
      </div>
      <Button onClick={() => props.restartGame()}>ทดสอบอีกครั้ง</Button>
      {!suggestion && (
        <Button onClick={() => props.navigateNextPage()}>
          รับข่าวสารเพิ่มเติม
        </Button>
      )}
      {/* <div className={styles.share_section}>
        <h2>แชร์ผลลัพธ์</h2>
        <Share url={result.shareUrl} />
      </div> */}
    </div>
  );
}

export default FinalResult;
